export const MODULENAME = {
  OEAPP: 'OeApp',
  AGENTAPP: 'AgentApp',
  HRMSAPP: 'HrmsApp',
  CIFAPP: 'CifApp',
  ANALYTICSAPP: 'AnalyticsApp',
  CHATBOTAPP: 'ChatbotApp',
};
